<template>
<!-- Header Start { -->
      <div id="header">
        <div class="header-area">

          <div class="head-left">
            <div class="logo" v-if="currentPage == 'Home'">
              <h1><router-link :to="{ name: 'Home'}"><img src="@/assets/images/common/logo.svg" alt="flexmoney"></router-link></h1>
            </div>
            <div class="link" v-else>
              <span class="btn-back" @click="$router.go(-1)"><img src="@/assets/images/common/ico_left.png" alt="뒤로가기" /></span>
              <span class="txt">{{ getPageTitle() }}</span>
            </div>
          </div>
            
          <div class="head-right">
            <div class="btn-home" v-if="getTradePage(currentPage)">
              <span class="img"><router-link :to="{ name: 'Home'}"><img src="@/assets/images/common/ico_home.png" alt="홈" /></router-link></span>
            </div>
            <div class="btn-write" v-if="currentPage == 'Community' && isLogin">
              <span class="img"><router-link :to="{ name: 'CommunityWrite'}"><img src="@/assets/images/common/ico_pencil.png" alt="글쓰기" /></router-link></span>
            </div>
            <div class="btn-write" v-if="currentPage == 'Qna' && isLogin">
              <span class="img"><router-link :to="{ name: 'QnaWrite'}"><img src="@/assets/images/common/ico_pencil.png" alt="문의하기" /></router-link></span>
            </div>
            <div class="btn-nav" @click="onNavOpen">
              <a href="javascript:;">
                <span class="img"><img src="@/assets/images/common/ico_nav.png" alt="메뉴" /></span>
              </a>
            </div>
          </div>

        </div>
      </div>

      <div id="navArea" :class="isNavOpen ? 'open':''">
        <div class="nav-top">
          <span class="home" @click="onNavClose"><router-link :to="{ name: 'Home'}"><img src="@/assets/images/common/ico_home.png" alt="홈" /></router-link></span>
          <span class="nav-close" @click="onNavClose"><img src="@/assets/images/common/ico_close2.png" alt="닫기" /></span>
        </div>

            <nav class="nav-area">
          <ul class="nav" @click="onNavClickHandle">
            <li>
              <a href="javascript:;" id="navi_0" class="depth-btn">상시모의투자</a>
              <ul class="depth">
                <li><router-link :to="{ name: 'Home' }" :class="currentPage == 'Home'?'on':''">상시모의투자</router-link></li>
                <li><router-link :to="{ name: 'Ranking' }" :class="currentPage == 'Ranking'?'on':''">랭킹</router-link></li>
                <li><router-link :to="{ name: 'ItemListStock',  params: {id: '0'} }" :class="currentPage == 'TradeStock' && currentLeagueType == 'normal'?'on':''">주식거래</router-link></li>
                <li><router-link :to="{ name: 'ItemListFutures',  params: {id: '0'} }" :class="currentPage == 'TradeFutures' && currentLeagueType == 'normal'?'on':''">선물거래</router-link></li>
                <li><router-link :to="{ name: 'ItemListCoin',  params: {id: '0'} }" :class="currentPage == 'TradeCoin' && currentLeagueType == 'normal' ?'on':''">코인거래</router-link></li>
                <li><router-link :to="{ name: 'ItemListCoinFutures',  params: {id: '0'} }" :class="currentPage == 'TradeCoinFutures' && currentLeagueType == 'normal' ?'on':''">코인선물</router-link></li>
                <!-- <li><router-link :to="{ name: 'TradeResultAll'}" :class="currentPage == 'TradeResultAll' ?'on':''">투자내역</router-link></li> -->
                <li><a href="javascript:;" @click="onClickTradeResultAll" :class="currentPage == 'TradeResultAll' ?'on':''">투자내역</a></li>
                <li v-if="menuRewardOnOff == 'Y' "><a href="javascript:;" @click="onClickTradeReward" :class="currentPage =='TradeReward'?'on':''">상금수령</a></li>               
              </ul>
            </li>
            <li>
              <a href="javascript:;" id="navi_4" class="depth-btn" >플렉스리그</a>
              <ul class="depth">
                <li><router-link :to="{ name: 'EventLeague', params: {type: '1'} }" :class="eventLeagueTapType == '1'?'on':''">전체</router-link></li>
                <li><router-link :to="{ name: 'EventLeague', params: {type: '2'} }" :class="eventLeagueTapType == '2'?'on':''">진행 중</router-link></li>
                <li><router-link :to="{ name: 'EventLeague', params: {type: '3'} }" :class="eventLeagueTapType == '3'?'on':''">참가 중</router-link></li>
                <li><router-link :to="{ name: 'EventLeague', params: {type: '4'} }" :class="eventLeagueTapType == '4'?'on':''">종료</router-link></li>
              </ul>
            </li>
            <li><router-link :to="{ name: 'Community' }" :class="currentPage == 'Community'?'on':''" id="navi_1">커뮤니티</router-link></li>
            <li>
              <a href="javascript:;" id="navi_2" class="depth-btn">고객센터</a>
              <ul class="depth">
                <li><router-link :to="{ name: 'Notice' }" :class="currentPage == 'Notice'?'on':''">공지사항</router-link></li>
                <li><a href="javascript:;" :class="currentPage == 'Qna'?'on':''" @click="onQna">1:1문의</a></li>
              </ul>
            </li>
            <li><a :href="`https://www.flextv.co.kr/redirects/signin?token=${cootoken}&redirectTo=/`" target="_blank">FLEXTV</a></li> 
            <li v-if="isLogin"><a href="javascript:;" id="navi_3" @click="onMypage" :class="currentPage == 'MyPage'?'on':''">마이페이지</a></li> 
          </ul>
        </nav>
                                    
        <div class="nav-bottom">
          <ul class="util" v-if="!isLogin">
            <li @click="onSignup"><router-link :to="{ name: ''}" class="btn btn-outline-secondary">회원가입</router-link></li>  
            <li @click="onSignin"><router-link :to="{ name: ''}" class="btn btn-danger">로그인</router-link></li>
          </ul>

          <ul class="util" v-else>
            <!-- <li class="user">
              <span class="text-truncate">
                <span class="ico-user"><img src="@/assets/images/common/ico_user.png" alt="user"></span>
                {{ store.state.user.memberData.NICK}}
              </span>
            </li> -->
            <li class="w-100" @click="onSignout"><button type="button" class="btn btn-danger w-100">로그아웃</button></li>
            <!-- <li @click="onMypage" ><router-link :to="{ name: ''}" class="btn btn-outline-secondary btn-sm">마이페이지</router-link></li> -->
          </ul>          
        </div>
      </div>

      <!-- } Header End -->  
</template>

<script>
//import Config from '../../public/config.js';
//import Config from '@/config.js';
import axios from '@/axios';
import { useStore } from 'vuex';
import { useRouter }from 'vue-router'
import {computed, getCurrentInstance, onMounted, ref, watch } from 'vue'
import {useApicall, useCheckLogin} from '@/composables/commonFn';
import VueCookies from "vue-cookies";

export default {
    props:{
      eventLeagueTapType:{
        type:String,
        require:false
      }
    },
   setup(){
    const trace = getCurrentInstance().appContext.config.globalProperties.$log;
    const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
    const store = useStore();
    const router = useRouter();
    const isLogin = computed(() => store.state.user.isLogin);
    const {apiCall_p, apiCall_pt, apiCall_gt} = useApicall();
    const isLocal =  store.state.common.isLocal;
    const { getMember , checkLogin} = useCheckLogin();
    const cootoken = ref(VueCookies.get('cootoken'));
    const currentSelect = computed(() => store.state.trade.currentPageId);
    const currentPage = computed(() => store.state.common.currentPage);
    const currentLeagueType = computed(() => store.state.trade.currentLeagueType);
    const wrapId = document.getElementById('wrap');
    const isNavOpen = ref(false);
    const menuRewardOnOff = computed(() => store.state.common.menuRewardState);

   // console.log("currentSelect, currentPage ==================>>", currentSelect.value, currentPage.value)
  

    checkLogin();
    getMember();
    
    watch(currentLeagueType, ()=>{
      console.log("currentLeagueType:", currentLeagueType.value)
    })
    
    onMounted(()=>{
      
    })
    const login_to_flexlife =  (_id, _pass)  =>{  
              var param = {}
              param.pid = "flexmoney";
              param.mid = _id;
              param.passwd = _pass;


            axios.post(process.env.VUE_APP_apiLifeUrl +'member/partnerlogin', param)
            .then(async function (response) {
                let json = response.data;	           
                if (json.returnCode == 1) {
                    if(json.resultMap.returnVal == 1)
                    {                 
                      // console.log("login_to_server:", json.resultMap)      
                      sessionStorage.setItem('groundToken', json.resultMap.token);      
                      // window.location.reload()    
                      var groundToken = sessionStorage.getItem('groundToken');
                      const data = await apiCall_p('member/tokenlogin',{"ssotoken":groundToken})
                      store.commit('user/CHANGE_IS_LOGIN', true);  
                      store.commit('user/CHANGE_MEMBER_DATA', data.member); 
                      sessionStorage.setItem('token', data.token);
                      store.dispatch('hts/setApplySpace'); 
                      store.dispatch('hts/setApplySpaceEventLeague');                         
                    }    
                    else
                    {
                      alert(json.message);
                    }
                }
                else 
                {
                    alert(json.message);			
                }
            })
            .catch (function (error) {
              console.log(error)
            })
            .then(function () {
                // always executed
            });
    }



    const onSignin =()=>{
       trace('onSignin~')
       //openWin(Config.URL.flexLifeUrl + 'plogin/login.html', 'login', 800, 500)
       //for test
      
       if(isLocal)
       {         
          login_to_flexlife('rangboq', 'dune77**')
        // login_to_flexlife('woo0050', 'test4858!')
        // login_to_flexlife('dodo01', '1q2w3e4r!')
       }
       else
       {
        //location.href = Config.URL.flexLifeUrl + `login?app=money&redirect_url=${Config.URL.flexMoneyUrl}`;
        location.href = process.env.VUE_APP_flexTvUrl + `partner/money/signin?&callbackUrl=${process.env.VUE_APP_flexMoneyUrl}`;
       }
    }

    const onSignout = async ()=>{
       trace('onSignout')
      // apiCall_gt('member/logout')
      
      emitter.emit('EVENT_ALERT',{title:"알림", body:"로그아웃 되었습니다."});

       if(store.state.user.fcmtoken)
       {
           var res =  await apiCall_pt('fcm/tokendeletepost', {'fcmtoken': store.state.user.fcmtoken})
           console.log('tokendeletepost', res );
       } 

       if(await apiCall_gt('member/logout'))
       {
        //sessionStorage.removeItem('groundToken');
          VueCookies.remove('cootoken')
          sessionStorage.removeItem('token'); 
          store.commit('hts/CHANGE_ORDERLIST', []);  
          store.commit('hts/CHANGE_ASSETLIST', []);
          store.commit('user/CHANGE_MEMBER_DATA', null);
          store.commit('user/CHANGE_IS_LOGIN', false);
          isNavOpen.value = false;
          wrapId.classList.remove('scr-none');
 
           router.push({
                name: 'Home',              
           });
       }  

    }
    const onMypage =()=>{
       trace('onMypage')
        router.push({
                name: 'MyPage',              
        });
    }
    const onQna = ()=>{
      if(isLogin.value) {
        router.push({
          name: 'Qna',
        });
      } else {
        emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 이용 가능합니다."});
      }
    }

    const onSignup = () => {
      //location.href = Config.URL.flexLifeUrl + `certificate?page=Signup&app=money&redirect_url=${Config.URL.flexMoneyUrl}`;
      location.href =process.env.VUE_APP_flexTvUrl + `partner/money/signup?&callbackUrl=${process.env.VUE_APP_flexMoneyUrl}`;
    }

    const onNavOpen = () => {      

      
      isNavOpen.value = true;
      wrapId.classList.add('scr-none');
      navCurrentCheck();
    }
    
    const onNavClose = () => {
      isNavOpen.value = false;
      wrapId.classList.remove('scr-none');
      navDepthReset();
    }

    const onNavClickHandle = (e) => {
      var btn = e.target; 
      var btnId = btn.id;

      if(btnId == 'navi_0' || btnId == 'navi_2' || btnId == 'navi_4') {
        btn.classList.toggle("active");
      } else {
        onNavClose();
      }
    }

    const navDepthReset = () => {
      var depthBtns = document.querySelectorAll('.depth-btn');
      depthBtns.forEach((depthBtn) => {
        if(depthBtn.classList.contains('active')) {
          depthBtn.classList.remove('active');
        }
      });
    }

    const navCurrentCheck = () => {

  
      var nav0 = document.getElementById('navi_0');
      var nav2 = document.getElementById('navi_2');
      var nav4 = document.getElementById('navi_4');
      
      if( 
          currentPage.value == 'Home' ||
          currentPage.value == 'Ranking' ||
          currentPage.value == 'TradeStock' ||
          currentPage.value == 'TradeFutures' ||
          currentPage.value == 'TradeCoin' ||
          currentPage.value == 'TradeCoinFutures' ||
          currentPage.value == 'TradeReward' ||
          currentPage.value == 'TradeResultAll'
        )
      {
        if( currentLeagueType.value == 'normal')
        {
           nav0.classList.add('active');
           if(nav4.classList.contains('active'))
           {
              nav4.classList.remove('active');
           }
          

        }
        else if( currentLeagueType.value == 'event')
        {
           nav4.classList.add('active');

          if(nav0.classList.contains('active'))
           {
              nav4.classList.remove('active');
           }
        }
       
      } else if( 
          currentPage.value == 'Notice' ||
          currentPage.value == 'Qna' 
        ) 
      {
        nav2.classList.add('active');
      } else if(currentPage.value == 'EventLeague') 
      {
        nav4.classList.add('active');
      }
    }

    const getPageTitle = () => {
      var tName = null;
      switch(currentPage.value)
      {
        case 'Ranking':
          tName = '랭킹'
          break;
        case 'TradeStock':
          tName = '주식거래'
          break;
        case 'TradeFutures':
          tName = '선물거래'
          break;
        case 'TradeCoin':
          tName = '코인거래'
          break;
        case 'TradeCoinFutures':
          tName = '코인선물'
          break;
        case 'Community':
          tName = '커뮤니티'
          break;
        case 'Community_View':
          tName = '커뮤니티'
          break;
        case 'Notice':
          tName = '고객센터'
          break;
        case 'Qna':
          tName = '고객센터'
          break;
        case 'MyPage':
          tName = '마이페이지'
          break;
        case 'Policy':
          tName = '이용약관'
          break;
        case 'Privacy':
          tName = '개인정보처리방침'
          break;
        case 'Community_write':
          tName = '글쓰기'
          break;
        case 'Qna_write':
          tName = '문의하기'
          break;
        case 'TradeReward':
          tName = '상금수령'
          break;
        case 'EventLeague':
          tName = '플렉스리그'
          break;
        case 'TradeResultAll':
          tName = '투자내역'
          break;
      }

      return tName;
    }

    const getTradePage = (cPage) => {
      if( 
          cPage == 'TradeStock' ||
          cPage == 'TradeFutures' ||
          cPage == 'TradeCoin' ||
          cPage == 'TradeCoinFutures'
        )
      {
        return true;
      } else {
        return false;
      }
    }


    const onClickTradeReward = () => {
        if (isLogin.value) {
          router.push({
            name:'TradeReward'
          });
        } else {
          emitter.emit('EVENT_ALERT',{title:"알림", body: "로그인 후 입장 가능합니다."});
        }
    }

    const onClickTradeResultAll = () => {
        if (isLogin.value) {
          router.push({
            name:'TradeResultAll'
          });
        } else {
          emitter.emit('EVENT_ALERT',{title:"알림", body: "로그인 후 입장 가능합니다."});
        }
    }

    return {
       isLogin,
       onSignin,
       onSignout,    
       onMypage,
       store,
       currentSelect,
       currentPage,
       onSignup,
       cootoken,
       onQna,
       isNavOpen,
       onNavOpen,
       onNavClose,
       onNavClickHandle,
       getPageTitle,
       getTradePage,
       currentLeagueType,
       onClickTradeReward,
       menuRewardOnOff,
       onClickTradeResultAll,
    }
   }
}
</script>

<style>

</style>